<template>
  <div class="notification-detail">
    <div class="custom-breadcrumbs">
      <span class="back-link" @click="onClickBack">{{ $t('menu.notifications') }}</span>
      <span class="separator"> / </span>
      <span class="current-page">{{ $t('components.detail') }}</span>
    </div>

    <div class="detail-container">
      <div class="top-container">
        <!-- <div class="tag">UPDATE</div> -->
        <div class="banner-content">
          <div class="text-content">
            <div class="title">
              {{ detailData.title }}
            </div>
            <div class="date">{{ detailData.notice_actual_time }}</div>
          </div>
        </div>
      </div>

      <div class="content-section">
        <div class="content-label">{{ $t('no_auth.notification_content') }}</div>
        <p class="txt">{{ detailData.content }}</p>
        <ChannelFee v-if="detailData.type === 1 && detailData.data" :fee-data="JSON.parse(detailData.data)" />

        <div v-if="detailData.notice_file_resp_list && detailData.notice_file_resp_list.length > 0" class="attachment-section">
          <div class="attachment-title">{{ $t('no_auth.attachment') }}</div>
          <div class="attachment-list">
            <div v-for="(file, index) in detailData.notice_file_resp_list" :key="index" class="attachment-item">
              <i class="el-icon-document" />
              <span class="file-name">{{ file.file_name }}</span>
              <el-button type="text" class="download-btn" @click="downloadFile(file.file_oss_url, file.file_name)">
                <i class="el-icon-download" />
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchNotificationDetail } from '@/api/system/system'
export default {
  name: 'Notification_Detail',
  components: {
    ChannelFee: () => import('@/layout/components/paycools/components/MessageManage/ChannelFee.vue')
  },
  data() {
    return {
      detailData: {}
    }
  },
  created() {
    const { user_detail_no } = this.$route.params
    if (user_detail_no) {
      this.getDetail({ user_detail_no })
    }
  },
  methods: {
    getDetail(data) {
      fetchNotificationDetail(data).then(res => {
        this.detailData = res.data
        this.$store.dispatch('user/getUnreadNotificationCount')
      })
    },
    onClickBack() {
      this.$router.push({ name: 'Notifications' })
    },
    downloadFile(url, fileName) {
      const link = document.createElement('a')
      link.href = url
      link.download = fileName
      link.target = '_blank'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }
}
</script>

<style scoped lang="scss">
.notification-detail {
  margin: 48px;
}
.custom-breadcrumbs {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  font-size: 16px;
  .back-link {
    color: #333333;
    cursor: pointer;
    font-weight: 600;
    &:hover {
      color: #3855F1;
    }
  }
  .separator {
    color: #999999;
    margin: 0 8px;
    font-weight: 600;
  }
  .current-page {
    color: #333333;
    font-weight: 600;
  }
}
.detail-container {
  background: #F8F9FA;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  overflow: hidden;
}
.top-container {
  padding: 24px 20px;
  position: relative;
  .tag {
    position: absolute;
    top: 24px;
    right: 20px;
    display: inline-block;
    padding: 4px 8px;
    background: #E2211C;
    border-radius: 4px;
    color: #fff;
    font-size: 12px;
  }
  .banner-content {
    display: flex;
    align-items: flex-start;
  }
  .text-content {
    flex: 1;
    padding-top: 8px;
  }
  .title {
    font-size: 20px;
    font-weight: 600;
    color: #212121;
    line-height: 28px;
  }
  .date {
    margin-top: 8px;
    font-size: 14px;
    color: #757575;
  }
}
.content-section {
  padding: 24px 20px;
  background: #fff;
  border-top: 1px solid #E3E3E3;
  .content-label {
    font-size: 16px;
    font-weight: 600;
    color: #212121;
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    &::before {
      content: '';
      width: 4px;
      height: 16px;
      background: #3855F1;
      margin-right: 8px;
      border-radius: 2px;
    }
    &::after {
      content: '';
      flex: 1;
      margin-left: 12px;
      border-top: 1px solid #E3E3E3;
    }
  }
  .txt {
    color: #333333;
    font-size: 14px;
    line-height: 24px;
    word-break: break-all;
    white-space: pre-wrap;
  }
  .attachment-section {
    margin-top: 24px;
    .attachment-title {
      color: #212121;
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 12px;
      display: flex;
      align-items: center;
      &::before {
        content: '';
        width: 4px;
        height: 16px;
        background: #3855F1;
        margin-right: 8px;
        border-radius: 2px;
      }
      &::after {
        content: '';
        flex: 1;
        margin-left: 12px;
        border-top: 1px solid #E3E3E3;
      }
    }
    .attachment-list {
      display: flex;
      flex-wrap: wrap;
      gap: 12px;
    }
    .attachment-item {
      display: flex;
      align-items: center;
      padding: 12px 16px;
      border: 1px solid #E0E0E0;
      border-radius: 8px;
      background: #F5F5F5;
      max-width: 300px;
      i.el-icon-document {
        font-size: 18px;
        color: #757575;
        margin-right: 8px;
        flex-shrink: 0;
      }
      .file-name {
        color: #333333;
        font-size: 14px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        flex: 1;
      }
      .download-btn {
        margin-left: 8px;
        padding: 0;
        flex-shrink: 0;
        i {
          font-size: 16px;
          color: #409EFF;
        }
      }
    }
  }
}
</style>
